import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/src/jquery";
import "bootstrap/dist/js/bootstrap.min.js";
import "ant-design-vue/dist/antd.css";
import axios from "axios";
import VueProgressBar from "vue-progressbar";
// import moment from 'moment'
import VueTelInput from 'vue-tel-input';
// import * as PusherPushNotifications from "@pusher/push-notifications-web";

import api from './api'
import FontAwesomeIcon from './plugins/font-awesome'

const options = {
  color: "#2049ba",
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.prototype.$http = axios;
Vue.prototype.$api = api;

Vue.use(Antd);
Vue.use(VueProgressBar, options);
Vue.use(VueTelInput);

// const beamsClient = new PusherPushNotifications.Client({
//   instanceId: "be0bb462-0a26-4276-a24e-b47ed1890954",
// });

// beamsClient.start()
//   .then(beamsClient => beamsClient.getDeviceId())
//   .then(deviceId =>
//     console.log('Successfully registered with Beams. Device ID:', deviceId)
//   )
//   .catch(console.error);

/*
 * Import Highlight.js theme
 * Find more: https://highlightjs.org/static/demo/
 */
import "highlight.js/styles/default.css";
Vue.config.productionTip = false

axios.defaults.withCredentials = true;
const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
